import {createContext, useContext} from 'react';

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */
function createCtx<A extends {} | null>(initialValue?: any) {
	const ctx = createContext<A | undefined>(initialValue);

	function useCtx(forceGetContext: true): A | undefined;
	function useCtx(forceGetContext?: false): A;
	/**
	 * A helper to create a Context and Provider with no upfront default value, and
	 * without having to check for undefined all the time.
	 * @param {Boolean} forceGetContext - forces component to work even if the context is not defined
	 */
	function useCtx(forceGetContext = false) {
		const c = useContext(ctx);

		if (typeof c === 'undefined' && !forceGetContext) {
			throw new Error('🔥 useCtx must be inside a Provider with a value.');
		}

		return c;
	}

	return [useCtx, ctx.Provider, ctx.Consumer] as const; // 'as const' makes TypeScript infer a tuple
}

export default createCtx;
